// Styles
import './BillingModule.css'

// Import components for re-export
import { BillingDashboard } from './components/BillingDashboard'
import FollowUpManager from './components/FollowUpManager/FollowUpManager'
import PatientAccountsList from './components/PatientAccounts/PatientAccountsList'
import AccountDetails from './components/FollowUpManager/AccountDetails/AccountDetails'
import CompensationFundManager from './components/CompensationFund/CompensationFundManager'
import { CreditNoteManager, CreditNoteForm } from './components/CreditNotes'
import { RefundManager, RefundForm } from './components/Refunds'
import {
  PaymentAllocationManager,
  UnallocatedPaymentsList,
  SplitPaymentsList,
  AllocationModal
} from './components/PaymentAllocation'
import { AuditTrailViewer } from './components/AuditTrail'
import BillingEnums, { TRANSACTION_TYPES } from './utils/enums'

// Main Dashboard
export { BillingDashboard }

// Core Components
export { FollowUpManager }
export { PatientAccountsList }
export { AccountDetails }
export { CompensationFundManager }

// Financial Controls
export { CreditNoteManager, CreditNoteForm }
export { RefundManager, RefundForm }
export { PaymentAllocationManager, UnallocatedPaymentsList, SplitPaymentsList, AllocationModal }

// Audit & Compliance
export { AuditTrailViewer }

// Utilities
export { BillingEnums, TRANSACTION_TYPES }
export * from './utils/helpers'

// API Functions
export * from './backend-integration/api'

// Default export for setup.js
export default BillingDashboard
